import "core-js/stable";
import "regenerator-runtime/runtime"
import React from 'react'
import {createRoot} from 'react-dom/client'
import {getDomContainer} from 'src/lib/getDomContainer'
import App from 'src/app'
import AppStatic from 'src/appStatic'
import {initGoogleAnalitics} from 'src/gAnalitics'

/**
 * Подключение Гуугл аналитикс
 */
(function(d) {
  if (GANAL) {
    const s = d.createElement('script');
    s.src = 'https://www.googletagmanager.com/gtag/js?id=G-S16ERLW93J';
    s.async = true;
    s.onload = initGoogleAnalitics
    d.body.append(s);
  }
})(document);

const rootEl = getDomContainer('root')
const ComponentApp = YSDK ? AppStatic : App
if (rootEl) {
  const root = createRoot(rootEl)
  root.render(<ComponentApp />);
}
